'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _StorageAdapter2 = require('./StorageAdapter');

var _StorageAdapter3 = _interopRequireDefault(_StorageAdapter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Implementation of a storage adapter which uses the browser's LocalStorage API to retrieve items from the storage
 *
 * @class
 */
var LocalStorageAdapter = function (_StorageAdapter) {
  (0, _inherits3.default)(LocalStorageAdapter, _StorageAdapter);
  (0, _createClass3.default)(LocalStorageAdapter, null, [{
    key: 'fromGlobals',

    /**
     * @method
     * @return {LocalStorageAdapter}
     */
    value: function fromGlobals() {
      var _window = window,
          localStorage = _window.localStorage;

      return new LocalStorageAdapter(localStorage);
    }

    /**
     * @param {Storage} localStorage see {@link https://developer.mozilla.org/en-US/docs/Web/API/Storage}
     */

  }]);

  function LocalStorageAdapter(localStorage) {
    (0, _classCallCheck3.default)(this, LocalStorageAdapter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocalStorageAdapter.__proto__ || (0, _getPrototypeOf2.default)(LocalStorageAdapter)).call(this));

    _this.props = { localStorage: localStorage };
    return _this;
  }

  /**
   * @method
   * @param {Promise.<AppEventEmitter, Error>} dispatchPromise  a promise which resolve with an event dispatcher
   * @param {Array<{name:String, value:*}>} nameValuePairsList
   * @param {String} entityId the id of the entity to link the values to
   * @return {Promise<Array<{name:String, value:*}>, Error>}
   */


  (0, _createClass3.default)(LocalStorageAdapter, [{
    key: 'handleSetBatchStorage',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        var localStorage;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context.abrupt('return', dispatchPromise.then(function (props) {

                  nameValuePairsList.map(function (nameAndValue) {
                    var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 2),
                        name = _nameAndValue[0],
                        value = _nameAndValue[1];

                    return ['apps/' + props.instanceId + '/state/' + entityId + '/' + name, value];
                  }).forEach(function (keyAndValue) {
                    var _keyAndValue = (0, _slicedToArray3.default)(keyAndValue, 2),
                        key = _keyAndValue[0],
                        value = _keyAndValue[1];

                    localStorage.setItem(key, (0, _stringify2.default)(value));
                  });

                  return nameValuePairsList;
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    /**
     * @method
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {*} value the value to store, will be `JSON serialized`
     * @param {String} entityId the id of the entity to link the values to
     * @return {Promise<*, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        var localStorage;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context2.abrupt('return', dispatchPromise.then(function (props) {
                  var key = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;

                  if (!value) {
                    localStorage.removeItem(key);
                  } else {
                    localStorage.setItem(key, (0, _stringify2.default)(value));
                  }

                  return value;
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    /**
     * @method
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {String} entityId the id of the entity to link the values to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise<*, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var localStorage;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context3.abrupt('return', dispatchPromise.then(function (props) {
                  var key = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;
                  var value = localStorage.getItem(key);

                  if (value) {
                    return JSON.parse(value);
                  }

                  return defaultValue;
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * @method
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {Array<String>} nameList the list of value names to retrieve
     * @param {String} entityId the id of the entity which the values are linked to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise.<Array<*>, Error>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var localStorage;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context4.abrupt('return', dispatchPromise.then(function (props) {
                  return nameList.map(function (name) {
                    return [name, 'apps/' + props.instanceId + '/state/' + entityId + '/' + name];
                  }).reduce(function (values, nameAndKey) {
                    var _nameAndKey = (0, _slicedToArray3.default)(nameAndKey, 2),
                        name = _nameAndKey[0],
                        key = _nameAndKey[1];

                    var value = localStorage.getItem(key);
                    if (value) {
                      values[name] = JSON.parse(value);
                    }
                    return values;
                  }, {});
                }));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return LocalStorageAdapter;
}(_StorageAdapter3.default);

exports.default = LocalStorageAdapter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/LocalStorageAdapter.js
// module id = 315
// module chunks = 0